'use client';

import { ProfileContext } from '@app/app/_context/ProfileContext/ProfileContext';
import { Profile } from '@app/domain/model/Profile';
import { ReactNode } from 'react';

interface Props {
    profile?: Profile | null;
    children: ReactNode;
}

export function ProfileContextProvider({ profile, children }: Props) {
    return <ProfileContext.Provider value={profile ?? null}>{children}</ProfileContext.Provider>;
}
